import { ShieldAlert } from "lucide-react";

export function AIDisclaimer({ text }) {
  return (
    <div className="flex items-start gap-2 rounded-sm border border-gold/20 bg-gold/5 px-3 py-2" data-testid="ai-disclaimer">
      <ShieldAlert className="w-3.5 h-3.5 text-gold mt-0.5 shrink-0" />
      <p className="text-[11px] leading-relaxed font-mono text-white/50">
        {text || "Educational analysis only. This AI does not identify suspects, assign guilt, or encourage contacting any party."}
      </p>
    </div>
  );
}

export default AIDisclaimer;
